import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import { queryCategoryList } from "@/api/materiel";
import { postDownload } from "@/utils";

export default function useCategory() {
  // 搜索条件
  const searchData = reactive({
    name: null,
    number: null,
    status: null,
  });

  // 搜索条件ref
  const searchRef = ref(null);

  // 上传组件ref
  const uploadRef = ref(null);

  // 上传组件的参数
  const uploadConfig = reactive({
    templateUrl: "/materialCategory/download", // 模板下载的url
    name: "物料类别导入模板.xlsx", // 模板文件名
  });

  // 表格列配置
  const columns = ref([
    {
      label: "类别名称",
      prop: "name",
    },
    {
      label: "类别编号",
      prop: "number",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "备注",
      prop: "remark",
      width: 200,
    },
    {
      label: "创建人",
      prop: "createName",
    },
    {
      label: "创建时间",
      prop: "createTime",
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 分页数据
  const pageParams = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取表格数据
  const getList = () => {
    tableLoading.value = true;
    queryCategoryList({
      ...searchData,
      page: pageParams.page,
      limit: pageParams.limit,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pageParams.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };

  // 点击导入
  const handleUpload = () => {
    uploadRef.value?.handleDialogOpen();
  };

  // 点击导出
  const handleDownload = () => {
    ElMessageBox.confirm("确定导出物料类别数据吗?", "导出", {
      confirmButtonText: "导出",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload(
          "/materialCategory/export",
          {
            ...searchData,
          },
          "物料类别.xlsx"
        );
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  return {
    searchData,
    searchRef,
    columns,
    tableData,
    tableLoading,
    pageParams,
    uploadRef,
    uploadConfig,
    getList,
    handleReset,
    handleUpload,
    handleDownload,
  };
}
